// utils/preview-service.js
import Vue from 'vue';

const PreviewConstructor = Vue.extend({
	data() {
		return {
			show: false,
			url: '',
			scale: 1,
			lastScale: 1,
			x: 0,
			y: 0,
			lastX: 0,
			lastY: 0,
			distance: 0
		};
	},
	render(h) {
		if (!this.show) return null;
		return h(
			'div',
			{
				class: 'global-preview-mask',
				on: {
					click: (e) => {
						if (e.target === e.currentTarget) this.close();
					},
					touchstart: this.handleStart,
					touchmove: this.handleMove,
					touchend: this.handleEnd
				},
				style: {
					position: 'fixed',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					backgroundColor: 'rgba(0,0,0,0.95)',
					zIndex: 10000,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					touchAction: 'none'
				}
			},
			[
				h('img', {
					attrs: { src: this.url },
					style: {
						maxWidth: '100%',
						maxHeight: '100%',
						objectFit: 'contain',
						transform: `translate3d(${this.x}px, ${this.y}px, 0) scale(${this.scale})`,
						transition: this.distance > 0 ? 'none' : 'transform 0.2s ease-out'
					}
				}),
				h(
					'div',
					{
						class: 'close-preview-btn',
						on: { click: this.close },
						style: {
							position: 'absolute',
							top: '40px',
							right: '20px',
							fontSize: '30px',
							color: '#fff'
						}
					},
					'×'
				)
			]
		);
	},
	methods: {
		open(url) {
			this.url = url;
			this.show = true;
			this.scale = 1;
			this.x = 0;
			this.y = 0;
		},
		close() {
			this.show = false;
		},
		handleStart(e) {
			if (e.touches.length === 2) {
				this.distance = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
			} else {
				this.lastX = e.touches[0].pageX - this.x;
				this.lastY = e.touches[0].pageY - this.y;
			}
		},
		handleMove(e) {
			e.preventDefault();
			if (e.touches.length === 2 && this.distance > 0) {
				const newDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
				this.scale = Math.min(Math.max(this.lastScale * (newDist / this.distance), 1), 3);
			} else if (this.scale > 1) {
				this.x = e.touches[0].pageX - this.lastX;
				this.y = e.touches[0].pageY - this.lastY;
			}
		},
		handleEnd() {
			this.distance = 0;
			this.lastScale = this.scale;
		}
	}
});

// 单例模式
let instance;
export const preview = (url) => {
	if (!instance) {
		instance = new PreviewConstructor().$mount();
		document.body.appendChild(instance.$el);
	}
	instance.open(url);
};
